<span class="font-medium-title-large">{{ title }}</span>
<span class="font-regular-body-large">
  {{ description }}
</span>
<form
  [formGroup]="tagSelectionForm"
  class="flex-c gap-32 align-self-stretch"
  (ngSubmit)="saveTags()">
  <app-tag-selector
    [selectedTags]="selectedTags"
    (selectedTagsChange)="selectedTagsChange($event)"></app-tag-selector>
  @if (enableLinkInput) {
    <div class="input-simple flex-1-1-0">
      <div class="input-label" for="linkTitle">
        Titel des Links{{
          fieldRequired(tagSelectionForm.get('linkTitle')) ? '*' : ''
        }}
      </div>
      <input
        class="input-field"
        formControlName="linkTitle"
        name="linkTitle"
        id="linkTitle"
        type="text"
        placeholder="Link Titel" />
      <app-error-message [formField]="tagSelectionForm.get('linkTitle')">
      </app-error-message>
    </div>
    <div class="input-simple flex-1-1-0">
      <div class="input-label" for="linkUrl">
        URL des Links{{
          fieldRequired(tagSelectionForm.get('linkUrl')) ? '*' : ''
        }}
      </div>
      <input
        class="input-field"
        formControlName="linkUrl"
        name="linkUrl"
        id="linkUrl"
        type="text"
        placeholder="https://www.example.com" />
      <app-error-message [formField]="tagSelectionForm.get('linkUrl')">
      </app-error-message>
    </div>
  }
  <div class="flex-r gap-16 justify-center">
    <button
      type="button"
      class="inwi-text-button-large-secondary flex-1-0-0"
      (click)="closeDialog()">
      <div class="button-content">
        <div class="button-text">Abbrechen</div>
      </div>
    </button>
    <button
      type="submit"
      class="inwi-text-button-large-primary flex-1-0-0"
      [disabled]="tagSelectionForm.invalid">
      <div class="button-content">
        <div class="button-text">Anwenden</div>
      </div>
    </button>
  </div>
</form>
